export type SpinnerSize = 'large' | 'default' | 'small' | 'xSmall';
